import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useApp } from "@/lib/AppContext";
import LangThemeToggle from "@/components/LangThemeToggle";

const T = {
  ar: {
    appName: "مغاسل القمر الأبيض",
    tagline: "خدمات غسيل احترافية",
    laundry: "المغسلة",
    wheel: "عجلة العروض",
    landing: "الرئيسية",
    about: "من نحن",
    contact: "تواصل معنا",
    orderNow: "اطلب الآن",
  },
  en: {
    appName: "White Moon Laundry",
    tagline: "Professional Laundry Services",
    laundry: "Laundry",
    wheel: "Offers Wheel",
    landing: "Home",
    about: "About",
    contact: "Contact",
    orderNow: "Order Now",
  }
};

export default function SharedHeader() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const isAr = lang === "ar";
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: tr.landing, href: "/" },
    { label: tr.laundry, href: "/laundry" },
    { label: tr.wheel, href: "/wheel" },
    { label: tr.about, href: "/about" },
    { label: tr.contact, href: "/contact" },
  ];

  const isActive = (href) => {
    if (href === "/") return location.pathname === "/";
    if (href === "/laundry") return location.pathname === "/laundry";
    if (href === "/wheel") return location.pathname === "/wheel";
    if (href === "/about") return location.pathname === "/about";
    if (href === "/contact") return location.pathname === "/contact";
    return false;
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border shadow-sm"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <img
            src="https://media.base44.com/images/public/user_69729b1c2410c5c031f1d29a/291b90bb1_.png"
            alt="logo"
            width="40"
            height="40"
            decoding="async"
            className="w-10 h-10 object-contain"
          />
          <div className="hidden sm:block">
            <p className="font-black text-foreground text-sm leading-tight">{tr.appName}</p>
            <p className="text-[10px] text-muted-foreground">{tr.tagline}</p>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map(l => (
            <Link
              key={l.href}
              to={l.href}
              className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all ${
                isActive(l.href)
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground/80 hover:text-primary hover:bg-primary/10"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* Right Actions */}
        <div className="flex items-center gap-2">
          <LangThemeToggle />
          <Link
            to="/laundry"
            className="hidden sm:inline-flex items-center gap-1.5 bg-primary text-primary-foreground font-bold px-4 py-2 rounded-xl text-sm hover:opacity-90 transition-all shadow-md"
          >
            🧺 {tr.orderNow}
          </Link>
          {/* Mobile hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden p-2 rounded-xl hover:bg-secondary transition-all"
          >
            <span className="text-xl">{menuOpen ? "✕" : "☰"}</span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-background/98 backdrop-blur-md border-b border-border px-4 pb-4 space-y-1">
          {navLinks.map(l => (
            <Link
              key={l.href}
              to={l.href}
              onClick={() => setMenuOpen(false)}
              className={`flex w-full px-4 py-3 text-sm font-semibold rounded-xl transition-all ${
                isActive(l.href)
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground hover:bg-secondary"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/laundry"
            onClick={() => setMenuOpen(false)}
            className="flex items-center justify-center gap-1.5 bg-primary text-primary-foreground font-bold px-4 py-3 rounded-xl text-sm mt-2"
          >
            🧺 {tr.orderNow}
          </Link>
        </div>
      )}
    </header>
  );
}